import { ConnectedPosition } from '@angular/cdk/overlay';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api/api.service';
import { NavServiceService } from 'src/app/services/nav-service.service';
import { PromptService } from 'src/app/services/prompt.service';
import { SharedService } from 'src/app/shared/shared.service';
import * as dayjs from 'dayjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent {


  displayContainer: boolean = false;
  positions: ConnectedPosition[] = [
    {
      originX: 'end',     // anchor to the right edge of the parent
      originY: 'bottom',  // anchor to the bottom of the parent
      overlayX: 'end',    // align popover’s right edge
      overlayY: 'top'     // align popover’s top edge
    }
  ];

  notificationData: any[] = [];
  
  constructor(
    private apiService: ApiService,
    private promptService: PromptService,
    private navService: NavServiceService,
    private sharedService: SharedService,
    private router: Router
  ){}

  toggleNotification(){

    const todayStr = dayjs().format('DD/MM/YYYY');

    const { today, others } = this.notificationData.reduce(
      (result, item: any) => {
        if (dayjs(item?.timestamp).format('DD/MM/YYYY') === todayStr) {
          result.today.push(item);
        } else {
          result.others.push(item);
        }

        return result;
      },
      {
        today: [],
        others: []
      }
    );

    this.sharedService.updateNotificationDisplay({today, others});
  }

  ngOnInit(){
    this.sharedService.getNotificationObservable().subscribe((isRefresh: any) => {
      if (isRefresh == true){
        this.getList();
      }
    });
    this.getList();
  }

  getList(){
    this.apiService.getNotification().subscribe((res: any) => {
      // console.log(res);
      if (res?.success == true){
        this.notificationData = res?.data?.items ?? [];

        if (this.notificationData.length != 0){
          this.notificationData = this.notificationData.map((item: any) => {
            return {
              ...item,
              message: this.getMessage(item),
              timestamp: item?.submitted_at ?? null
            }
          });

        }
      }
      else {
        this.notificationData = [];
        this.promptService.openSnackBar(res?.message);
      }
    }, (error)=> {
      this.notificationData = [];

    })
  }

  getMessage(data:any){
    let message = "";

    let getDoc = data?.document?.S_STORE + (data?.document?.S_DOC_NO ? ('-' + data?.document?.S_DOC_NO) : data?.document?.S_DOC_NO);

    switch (data?.document_type){
      case 'stock_in':
        message = "Stock In <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'stock_out':
        message = "Stock Out <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'qty_adjustment':
        message = "Quantity Adjustment <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'cost_adjustment':
        message = "Cost Adjustment <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'purchase_request':
        message = "Purchase Request <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'transfer_in':
        message = "Transfer In <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'transfer_out':
        message = "Transfer Out <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'purchase_order':
        message = "Purchase Order <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'stock_receive':
        message = "Goods Receipt Note <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'stock_return':
        message = "Supplier Return Note <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'requisition_note':
        message = "Requisition Note <b>" + getDoc + "</b> is pending for approval";
        break;
      case 'stock_take':
        message = "Stock Take <b>" + getDoc + "</b> is pending for approval";
        break;
      default:
        message = "<b>" + getDoc + "</b> is pending for approval";
        break;
    }

    message = message.replaceAll('<b>', '#');
    message = message.replaceAll('</b>', '');
    return message;
  }



}
